<template>
  <div class="Inspection1">
    <h1 id="heading">Bewertung der Biegewechsel pro Jahr</h1>
    <v-divider></v-divider>
    <div class="justify-center">
      <h3 style="margin-top: 1px;">Berechnung der Biegewechsel</h3>
      <v-container>
        <v-layout>
          <v-flex>
            <div class="description">
              <v-dialog v-model="dialogBW" max-width="500px" :retain-focus="false">
                <template v-slot:activator="{ on }">
                  <v-btn color="green" x-small fab v-on="on">
                    <v-icon color="white" small>fas fa-info</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar color="green" height="50px">
                    <v-toolbar-title style="color: white; font-size: 130%">Biegewechsel je Fahrspiel</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn small @click="closeBW" icon>
                      <v-icon color="white">fas fa-times</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text style="font-size: 100%;">
                    <p
                      class="paramDesc"
                    >
                    <br>
                    <b>Definition Biegewechsel:</b> <br>
Anzahl der umfahrenen Seilscheiben eines individuellen Seiles je Fahrspiel. <br><br>
<b>Bei Umlaufbahn:</b> <br>
Zählen Sie die Anzahl der Seilbiegungen über Seilscheiben <u>bei einem gesamten Seilumlauf.</u> <br><br>
<b>Bei Pendelbahn:</b> <br>
Zählen Sie im Falle:<br><br>
a) <u>einer gespleißten Zugseilschleife</u> die größte Anzahl der Seilbiegungen über
Seilscheiben, die bei einer Bergwärtsfahrt in einer der Stationen auftritt.<br><br>
b) <u>eines oberen, unteren oder mittleren Zugseiles oder eines Gegenseiles</u> die
Anzahl der Seilbiegungen über Seilscheiben, die an diesem bei einer
Bergwärtsfahrt auftritt.</p>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-text-field
              class="txtField"
              outlined
              v-model="bending"
              label="Biegewechsel je Fahrspiel"
              type="number"
              step="1"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <div class="description">
              <v-dialog v-model="dialogBS" max-width="500px" :retain-focus="false">
                <template v-slot:activator="{ on }">
                <v-btn color="green" v-on="on" x-small fab>
                  <v-icon color="white" small>fas fa-info</v-icon>
                </v-btn>
                </template>

                <v-card>
                  <v-toolbar color="green" height="50px">
                    <v-toolbar-title style="color: white; font-size: 130%">Betriebsstunden</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn small @click="closeBS" icon>
                      <v-icon color="white">fas fa-times</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text style="font-size: 100%;">
                    <p class="paramDesc">Betriebszeit, in Stunden pro Jahr [Std/J]</p>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-text-field
              class="txtField"
              outlined
              v-model="uptime"
              label="Betriebsstunden pro Jahr"
              type="number"
              step="1"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <div class="description">
              <v-dialog v-model="dialogGW" max-width="500px" :retain-focus="false">
                <template v-slot:activator="{ on }">
                  <v-btn color="green" slot="activator" v-on="on" x-small fab>
                    <v-icon color="white" small>fas fa-info</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar color="green" height="50px">
                    <v-toolbar-title style="color: white; font-size: 130%">Durchschnittliche Fahrgeschwindigkeit</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn small @click="closeGW" icon>
                      <v-icon color="white">fas fa-times</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text style="font-size: 100%;">
                    <p class="paramDesc">Durchschnittliche Fahr- bzw. Seilgeschwindigkeit in Meter pro Sekunde [m/s]</p>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-text-field class="txtField" outlined v-model="vel" label="Durchschnittliche Fahrgeschwindigkeit in m/s" type="number"
              step="1"></v-text-field>
          </v-flex>
          <v-flex>
            <div class="description">
              <v-dialog v-model="dialogSL" max-width="500px" :retain-focus="false">
                <template v-slot:activator="{ on }">
                  <v-btn color="green" slot="activator" v-on="on" x-small fab>
                    <v-icon color="white" small>fas fa-info</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar color="green" height="50px">
                    <v-toolbar-title style="color: white; font-size: 130%">Seillänge</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn small @click="closeSL" icon>
                      <v-icon color="white">fas fa-times</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text style="font-size: 100%;">
                    <p class="paramDesc">Seillänge, in Meter [m]<br><br>
                      Bei <u>Pendelbahnen mit einer Zugseilschleife</u> nur die Länge
                      des Abschnittes, welche durch jene Station mit den
                      meisten Seilscheiben durchfahren wird (...vereinfacht die
                      halbe Seillänge).
                    </p>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-text-field class="txtField" outlined v-model="ropelength" label="Seillänge in Meter" type="number"
              step="1"></v-text-field>
          </v-flex>
          <v-flex>
            <v-btn color="blue" @click="calculate" fab style="margin-top: 40%;">
              <v-icon color="white">fas fa-calculator</v-icon>
            </v-btn>
            <div style="display: block; text-align: center;">
              berechnen
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>

            <h2 v-if="!manualSelect">Biegewechsel/Jahr: {{bendingRes}}</h2>
            <h2 v-else>Biegewechsel/Jahr: Berechnung manuell durchgeführt</h2>

          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-container>
      <h3>Führt das Litzenseil eine pendelnde oder umlaufende Bewegung aus?</h3>
      <div>
        <v-dialog v-model="dialogUml" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" v-on="on" x-small fab>
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-toolbar color="green" height="80px">
              <v-toolbar-title
                style="color: white; font-size: 99%"
              >Biegewechsel pro Jahr für Litzenseile in umlaufender Bewegung</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn small @click="closeUml" icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-img
              src="../../statics/images/Sessellift.jpg"
              style="height: 50%"
            >
              
            </v-img>

            <v-card-text style="font-size: 100%;">
              <p style="text-decoration: underline;">
                <strong>Beispiel:</strong> Sesselbahn
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-btn @click="showUmlaufend" v-if="this.umlaufend" color="blue" class="ma-2 btnCard"><span style="color: white; font-size: 120%;">Umlaufend</span></v-btn>
        <v-btn
          @click="showUmlaufend"
          v-if="!this.umlaufend"
          color="blue"
          class="ma-2 btnCard"
          outlined
        ><span style="font-size: 120%;">Umlaufend</span></v-btn>
        <v-btn @click="showPendelnd" v-if="this.pendelnd" color="blue" class="ma-2 btnCard"><span style="color: white; font-size: 120%;">Pendelnd</span></v-btn>
        <v-btn
          @click="showPendelnd"
          v-if="!this.pendelnd"
          color="blue"
          class="ma-2 btnCard"
          outlined
        ><span style="font-size: 120%;">Pendelnd</span></v-btn>
        <v-dialog v-model="dialogPen" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" v-on="on" x-small fab>
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-toolbar color="green" height="80px">
              <v-toolbar-title
                style="color: white; font-size: 99%"
              >Biegewechsel pro Jahr für Litzenseile in pendelnder Bewegung</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn small @click="closePen" icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-img src="../../statics/images/Standseilbahn.jpg"></v-img>

            <v-card-text style="font-size: 100%;">
              <p style="text-decoration: underline;">
                <strong>Beispiel:</strong> oberes Zugseil einer Standseilbahn
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <div v-if="umlaufend">
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="itemsUmlaufend"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
                @click="manualSelected(true);"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
    <div v-if="pendelnd">
      <v-spacer></v-spacer>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="itemsPendelnd"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
                @click="manualSelected(true);"
              >
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection1",
  props: ["assessmen"],
  data() {
    return {
      manualSelect: false,
      dialog: false,
      dialogBW: false,
      dialogBS: false,
      dialogGW: false,
      dialogSL: false,
      dialogPen: false,
      dialogUml: false,
      isLitzenseil: false,
      row: null,
      counter: 1,
      umlaufend: true,
      pendelnd: false,
      question: true,
      assessName: "",
      assessHeader: "",
      assessActual: 0,
      assessment: 0,
      bendingRes: 0,
      bending: "",
      uptime: "",
      vel: "",
      ropelength: "",
      itemsUmlaufend: [
        { name: "unter 5.000", assess: 0 },
        { name: "5.000 bis 25.000", assess: 1 },
        { name: "25.000 bis 70.000", assess: 2 },
        { name: "über 70.000", assess: 3 }
      ],
      itemsPendelnd: [
        { name: "unter 5.000", assess: 0 },
        { name: "5.000 bis 75.000", assess: 1 },
        { name: "75.000 bis 150.000", assess: 2 },
        { name: "über 150.000", assess: 3 }
      ],
      headers: [
        {
          text: "Biegewechsel pro Jahr",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  computed: {},
  methods: {
    manualSelected(val){
      this.manualSelect = val;
    },
    showUmlaufend() {
      this.umlaufend = true;
      this.pendelnd = false;
      this.calculate();
      if (isNaN(this.bendingRes)){
        this.manualSelected(true)
      }
    },
    showPendelnd() {
      this.pendelnd = true;
      this.umlaufend = false;
      this.calculate();
      console.log('isNan')
      if (isNaN(this.bendingRes)){
        this.manualSelected(true)
      }
    },
    nextPage() {
      if (this.umlaufend) {
        switch (this.assessment) {
          case 0:
            this.assessName = "Unter 5000";
            break;
          case 1:
            this.assessName = "5000 bis 25000";
            break;
          case 2:
            this.assessName = "25000 bis 70000";
            break;
          case 3:
            this.assessName = "Über 70000";
        }
      }
      if (this.pendelnd) {
        switch (this.assessment) {
          case 0:
            this.assessName = "Unter 5000";
            break;
          case 1:
            this.assessName = "5000 bis 75000";
            break;
          case 2:
            this.assessName = "75000 bis 150000";
            break;
          case 3:
            this.assessName = "Über 150000";
        }
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Biegewechsel pro Jahr";

      var type = "Pendelnd: ";
      if (this.umlaufend)
        type = "Umlaufend: ";

      

      this.$emit("assessChanged", this.assessmen);
      if (!this.manualSelect) {
        this.$emit("assessmentName", type + this.assessName + "  (Biegewechsel je Fahrspiel: " + this.bending + " Biegewechsel | Betriebsstunden: " + this.uptime + " h | Geschwindigkeit: " + this.vel + " m/s | Seillänge: " + this.ropelength + " m)");
      } else {
        this.$emit("assessmentName", type + "manuelle Punktevergabe - " + this.assessName);
      }
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("prevPage1", true);
      this.$emit("prevPage2", false);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    previousPage(){
      this.$emit("InspBefore", true);
      this.$emit("InspActual", false);
    },
    calculate() {
      this.manualSelected(false);
      this.bendingRes =
        this.bending * this.uptime * (this.vel / this.ropelength) * 3600;
      this.bendingRes = Number(this.bendingRes.toFixed(0));
      // this.$store.commit("calculationParameters", [this.bending, this.uptime, this.vel, this.ropelength]);

      if (this.umlaufend) {
        if (this.bendingRes < 5000) {
          this.assessment = 0;
        }
        if (this.bendingRes > 5000 && this.bendingRes < 25000) {
          this.assessment = 1;
        }
        if (this.bendingRes > 25000 && this.bendingRes < 70000) {
          this.assessment = 2;
        }
        if (this.bendingRes > 70000) {
          this.assessment = 3;
        }
      } else {
        if (this.bendingRes < 5000) {
          this.assessment = 0;
        }
        if (this.bendingRes > 5000 && this.bendingRes < 75000) {
          this.assessment = 1;
        }
        if (this.bendingRes > 75000 && this.bendingRes < 150000) {
          this.assessment = 2;
        }
        if (this.bendingRes > 150000) {
          this.assessment = 3;
        }
      }
    },
    close() {
      this.dialog = false;
    },
    closeBW() {
      this.dialogBW = false;
    },
    closeBS() {
      this.dialogBS = false;
    },
    closeGW() {
      this.dialogGW = false;
    },
    closeSL() {
      this.dialogSL = false;
    },
    closePen() {
      this.dialogPen = false;
    },
    closeUml() {
      this.dialogUml = false;
    }
  },
  created() {
    var ropeType = this.$store.state.facilityList.find(x => x.id == this.$store.state.inspectingFacilityID).ropeList.find(x => x.id == this.$store.state.inspectingRopeID).rope;
    // var ropeType = this.$store.state.facilityList.find(x => x.id == this.$store.state.inspectingFacilityID).ropeList[this.$store.state.inspectingRopeID].rope;
    if (ropeType.includes("vollverschlossen")) {
      this.assessment = 0;
      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    }
  }
};
</script>

<style>
.Inspection1 {
  background-color: white;
  width: 80%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.radioGroup {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30%;
}

.DataTable {
  width: 90%;
  margin-top: 2%;
  margin-left: 5%;
  border: 1px solid black;
  border-radius: 3px;
}

#heading {
  font-size: 200%;
}

.txtField {
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
}

table.v-table thead th {
  font-size: 120%;
}

.description {
  padding-top: 3%;
  text-align: center;
  padding-left: 10%;
  padding-right: 10%;
}

.card {
  text-align: center;
}

.btnCard {
  margin-left: 0%;
}

.paramDesc {
  font-size: 120%;
  padding: 0% 2% 0% 2%;
}
</style>
